import { ReactElement, ReactNode } from 'react'

function SegmentedButtonOption({name, value, checked, setChecked, children}: {
	name: string
	value: string
	checked: boolean
	setChecked: () => void
	children: ReactNode
}) {
	return <label>
		<input type="radio" name={name} value={value} checked={checked} onChange={ev => {
			setChecked()
		}}/> {children}
	</label>
}

export function SegmentedButton({name, value, setValue, children}: {
	name: string
	value: string
	setValue: (newValue: string) => void
	children: ReactElement<HTMLOptionElement>[]
}) {
	for (const option of children) {
		option.props.value
	}
	return <div data-segmented-button>
		{children.map(option => <SegmentedButtonOption name={name} key={option.props.value} value={option.props.value} checked={value === option.props.value} setChecked={() => setValue(option.props.value)} children={option.props.children as ReactNode}/>)}
	</div>
}
